<template>
<div>
    <bar-manut 
        single-entity="Item em Destaque" 
        plural-entity="Itens em Destaque" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <div>
        <div class="default-container">
            
            <div class="row">
                <!-- <form-field v-model="destaq.coddestaq" type="text" col="3" :disabled="true"></form-field> -->

                <form-field ref="descricao" v-model="destaq.descricao" type="text" col="12"
                    case="normal" name="descricao" :v-errors="errors" 
                    label="Descrição"></form-field>
            </div>                
            <div class="row">
                <form-field v-model="destaq.dtinicio" type="date" col="3" 
                        name="dtinicio" :v-errors="errors" label="Data de Início"></form-field>
                <form-field v-model="destaq.dttermino" type="date" col="3" 
                        name="dttermino" :v-errors="errors" label="Data de Término"></form-field>                                                
            </div>                  

            <label-title title="Inclusão de Itens" class="nb-margin-bottom nb-margin-top"></label-title>
            <div>               
                <div class="col-md-12 col-12">
                    
                    <div class="">
                        <varejo-add-item ref="item" v-model="coditem" :add-button="true" @onselect="handleNewItem" :exibePreco="false"></varejo-add-item>                                
                    </div>
                </div>
                <div class="col-md-12 col-12">
                    <div class="mainbox" v-for="(valor, index) in destaqit" :key="index">                    
                        <div class="box">
                            <div class="row align-items-center">                                                        
                                <div class="col-md-1 col-1 text-center">
                                    <img v-if="valor.url" :src="valor.url" class="mx-auto d-block img-thumbnail" 
                                    alt="Logotipo" style="max-width: 45px; max-height: 45px; cursor: pointer;">
                                    <i v-if="!valor.url" class="fa fa-camera mx-auto d-block" style="font-size: 25px; color: silver"></i>
                                </div>
                                <div class="col-md-2 col-1">
                                    <v-label label="Código do Item"></v-label><br>
                                    <span class="lbl">{{ valor.codigo }}</span>
                                </div>
                                <div class="col-md-7 col-2">
                                    <v-label label="Item"></v-label><br>
                                    <span class="lbl">{{ valor.descricao }}</span>
                                </div>

                                <div class="col-md-1 col-2">
                                    <v-button label="" title="Excluir Item" icon="fa-trash" @click="handleDeleteVariavel(index)"></v-button>
                                </div>                            
                            </div>
                        </div>
                    </div>
                </div>
                
                                    
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import VarejoAddItem from '../forms-varejo/varejo-add-item'

export default {
    props: {
        index: '',
        crud: '',
    },

    components: {
        VarejoAddItem
    },

    data() {
        return {
            crudText: '',
            destaq: {...this.$store.getters.getEntities.destaq},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
            destaqit: [],
            coditem: '',
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }
    },

    watch: {
    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.destaq.coddestaq)
        },

        handleSave () {
            //BOTAO SALVAR
            var valido = true;

            if (this.destaq.dtinicio > this.destaq.dttermino) {
                valido = false
                this.$erpToastError('A data de término não pode ser maior que a data de início')
            }

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else if (valido) {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            this.apiDelete()
        },       

        handleDeleteVariavel (index) {            
            this.destaqit.splice(index,1)
        },

        handleNewItem (selectedItem) {           
            // Verifica se foi selecionado algum item
            if (!selectedItem) return            

            // Verifica se o item já não foi adicionado
            if (this.destaqit) {
            for(var i=0; i<this.destaqit.length; i++) {
                if(this.destaqit[i].coditem === selectedItem.coditem) {
                    return
                }
            }
            }

            var p = {
                coditem: selectedItem.coditem,
                coddestaq: '',
                coddestaqit: '',
                descricao: selectedItem.descricao
            }
            this.destaqit.push(p)        
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadDestaq', { id: this.index } )
            if (this.$store.getters.getDestaq) {
                this.destaq = {...this.$store.getters.getDestaq}
                // this.destaqit = JSON.parse(this.destaq.valores)
                this.destaqit = this.destaq.destaqit
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/destaq/' + this.destaq.coddestaq

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/destaq/'
            this.destaq.destaqit = this.destaqit
            var sendData = { destaq: this.destaq }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },

    },

    beforeCreate () {

    },

    created () {
        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
            this.destaq.stdestaq = 'A'
            this.destaq.dtinicio = this.$getDate()
        } else {
            this.loadData()  
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.descricao.focus()
        })

    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/destaq-form.vue